import React from 'react';
import { OrdersTab } from './OrdersTab';

/**
 * Reports tab — now serves as a dedicated **Dispatch Details** view.
 *
 * Renders the full Order Management tab but with two restrictions:
 *   1. The status filter is locked to `'dispatched'` (dropdown disabled).
 *   2. The "Clear All" filter button is hidden so the user can't escape the lock.
 *
 * All other behavior — search, sort, exports, dispatch / delivery actions —
 * remains identical to the main Orders tab. The legacy "Dealer-wise Report"
 * generator was removed per user request; dispatch reporting is now the
 * canonical use of this tab.
 */
export const ReportsTab = (props) => (
  <OrdersTab {...props} restrictTo="dispatched" />
);
